import Link from '@/styles/components/link'

export const MarkdownStyle = {
  display: 'flex',
  flexFlow: 'column nowrap',

  width: 'full',

  fontSize: 'md',
  letterSpacing: '0.54px',
  wordBreak: 'break-word',
  fontFamily: 'blog',

  '& > *': {
    opacity: 0.6,
    transition: 'all 300ms',
  },

  '& > *.visible': {
    opacity: 1,
  },

  a: {
    ...Link.baseStyle,
    ...Link.variants.regular,
    fontWeight: 'medium',
    color: 'primary.300',
    textDecoration: 'underline',
    whiteSpace: 'normal',
  },

  p: {
    fontWeight: 'light',
    lineHeight: '1.7',
    mt: 3,
  },

  hr: {
    display: 'block',
    width: 'full',
    maxWidth: '360px',
    margin: '0 auto',
    border: 'none',
    borderBottom: '1px solid #d8d8d8',
  },

  h2: {
    fontWeight: 'medium',
    fontSize: {
      base: '3xl', // 28
      md: '3.5xl', // 32
    },
    marginTop: '28px',
    mt: 8,
    fontFamily: 'heading',
  },

  h3: {
    fontWeight: 'medium',
    fontSize: {
      base: 'xl', // 20
      md: '2xl', // 24
    },
    marginTop: '28px',
    mt: 8,
    fontFamily: 'heading',
  },

  h4: {
    fontWeight: 'medium',
    fontSize: {
      base: 'lg', // 18
      md: 'xl', // 20
    },
    marginTop: '28px',
    mt: 8,
    fontFamily: 'heading',
  },

  img: {
    mx: 'auto',
    my: 4,
  },

  blockquote: {
    paddingLeft: '30px',
    borderLeft: '3px solid #52686c',
    whiteSpace: 'pre-line',
  },

  ul: {
    mt: 4,
    listStyleType: 'disc',
    display: 'grid',
    gap: '10px',
    paddingLeft: '40px',
  },

  ol: {
    mt: 4,
    listStyleType: 'decimal',
    display: 'grid',
    gap: '10px',
    paddingLeft: '40px',
  },

  li: {
    fontWeight: 'light',
    paddingLeft: '10px',
  },

  pre: {
    padding: '20px',
    overflowX: 'auto',
    overflowY: 'hidden',
    backgroundColor: 'rgba(218, 218, 218, 0.3)',
    WebkitOverflowScrolling: 'touch',

    '*': {
      padding: '0 !important',
      borderRadius: '0 !important',
      backgroundColor: 'transparent !important',
    },
  },

  code: {
    padding: '3px 5px 5px',
    borderRadius: '4px',
    backgroundColor: 'rgba(218, 218, 218, 0.3)',
    fontFamily: 'monospace',
  },

  strong: {
    fontWeight: 'medium',
  },

  '.gist': {
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',
    marginTop: '8px',
  },

  '&__caption': {
    display: 'block',
    marginTop: '-24px',
    color: '#1a1a1a',
    fontSize: 'xs',
    letterSpacing: '0.54px',
    textAlign: 'center',
  },
}
